import api from '../api';
let apiUrl = 'user-payment-methods';

const state = {
    data: [],
    paymentMethod: {
        data: {},
        meta: {}
    }
};

const actions = {
    index: async ({ commit }, config) => {
        return await api
            .get(`/api/v1/${apiUrl}`, config)
            .then((response) => {
                commit('set', response.data);
                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    },
    show: async ({ commit }, id) => {
        return await api
            .get(`/api/v1/${apiUrl}/${id}`)
            .then((response) => {
                commit('setPaymentMethod', response.data);
                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    },
    store: ({ commit, dispatch }, data) => {
        return api
            .post(`/api/v1/${apiUrl}`, data)
            .then((response) => {
                dispatch('index');
                return response.data;
            })
            .catch((error) => {
                console.error(error);
            });
    },
    update: ({ commit, dispatch }, data) => {
        return api
            .put(`/api/v1/${apiUrl}/${data.id}`, data)
            .then((response) => {
                dispatch('index');
                return response.data;
            })
            .catch((error) => {
                console.error(error);
            });
    },
    delete: ({ commit, dispatch }, data) => {
        return api
            .delete(`/api/v1/${apiUrl}/${data.id}`, data)
            .then((response) => {
                dispatch('index');
                return response.data;
            })
            .catch((error) => {
                console.error(error);
            });
    }
};

const mutations = {
    set(state, data) {
        state.data = data;
    },
    setPaymentMethod(state, data) {
        state.paymentMethod.data = data.data;
        state.paymentMethod.meta = data.meta;
    }
};

const getters = {
    get: (state) => {
        return state.data;
    },
    getMeta: (state) => {
        return state.meta;
    },
    getPaymentMethod: (state) => {
        return state.paymentMethod.data;
    },
    getPaymentMethodMeta: (state) => {
        return state.paymentMethod.meta;
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
